import React, { ChangeEventHandler, FC, ReactNode } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

interface CheckboxLabelProps {
  readonly children?: ReactNode;
  readonly id: string;
  readonly name?: string;
  readonly checked?: boolean;
  readonly disabled?: boolean;
  readonly onChange?: ChangeEventHandler<HTMLInputElement>;
}

export const CheckboxLabel: FC<CheckboxLabelProps> = ({
  id,
  disabled,
  children,
  name,
  checked,
  onChange,
}) => {
  return (
    <FormGroup check className="mt-10">
      <Input
        checked={checked}
        disabled={disabled}
        id={id}
        name={name}
        onChange={onChange}
        type="checkbox"
      />
      <Label check for={id}>
        {children}
      </Label>
    </FormGroup>
  );
};
